<template>
  <progress-bar class="progress m-0 p-0 rounded-0" :percentage-done="progressPercentage" />
</template>

<script>
import ProgressBar from '@/components/progress-bar'
import { mapGetters } from 'vuex'

export default {
  components: { ProgressBar },

  computed: {
    ...mapGetters(['progressPercentage'])
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

.progress {
  height: 10px;

  @include breakpoints.screen-mobile-only {
    height: 9px;
  }
}
</style>
